<template>
  <v-progress-circular :size="size" color="primary" indeterminate />
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    size?: number;
  }>(),
  {
    size: 40,
  },
);
</script>
